import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-confirmar-datos',
    templateUrl: './modal-confirmar-datos.component.html',
    styleUrls: ['./modal-confirmar-datos.component.css'],
    standalone: false
})
export class ModalConfirmarDatosComponent {

  constructor(
    private dialogRef: MatDialogRef<ModalConfirmarDatosComponent>
  ) {}

  cerrar() {
    this.dialogRef.close(false); // devuelve false al cerrar sin confirmar
  }

  confirmar() {
    this.dialogRef.close(true); // devuelve true si confirma
  }
}


